const InputSkeleton = () => {
    return (
        <div
            role='status'
            className='w-full animate-pulse'
        >
            <div className='h-10 bg-WHMLightGrey rounded-[5px] dark:bg-WHMGrey w-full'></div>
        </div>
    )
}

export default InputSkeleton